exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nnav.navbar[data-v-f4632fc2] {\n  height: 62px;\n  background-color: #ffffff;\n  width: 100%;\n}\n.nav-back[data-v-f4632fc2] {\n  margin: 0 0 0 5px;\n}\n.nav-left[data-v-f4632fc2],\n.nav-right[data-v-f4632fc2] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.nav-left .nav-item[data-v-f4632fc2] {\n  margin: 0 12px 0 15px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f4632fc2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reports/ratings/CompanyRatingsHeader.vue
// module id = UoSf
// module chunks = 0